import axios from '../utils/request';

// 列表
export const getusersList = params => {
  return axios.get('/TemporaryUsers/show', {
    params,
  });
};
// 支付
export const payment = data => {
  return axios.post('/TemporaryUsers/pay', data);
};
// 无牌车入场
export const getEnterList = data => {
  return axios.post('/TemporaryUsers/enter', data);
};
// 无牌车无费用出场开闸
export const open = data => {
  return axios.post('/TemporaryUsers/open', data);
};

// 捷顺
// 列表
export const getusersListjieshun = params => {
  return axios.get('/jieShun/show', {
    params,
  });
};
// 支付
export const paymentjieshun = data => {
  return axios.post('/jieShun/pay', data);
};
// 无牌车入场
export const getEnterListjieshun = data => {
  return axios.post('/jieShun/enter', data);
};
// 无牌车无费用出场开闸
export const openjieshun = data => {
  return axios.post('/jieShun/open', data);
};

// 是否需要登记
export const getIsNeedSign = data => {
  return axios.get('/TemporaryUsers/visitor_registration_status', {
    params: data,
  });
};

// 获取车牌号
export const getLicensePlate = data => {
  return axios.get('/TemporaryUsers/visitor_registration', {
    params: data,
  });
};

// 登记
export const visitorRegistration = data => {
  return axios.post('/TemporaryUsers/visitor_registration', data);
};
